<div class="header {{color}}">
  <div class="left">
    <ng-content select="[icon]"></ng-content>
    <h3>{{ title }}</h3>
  </div>
  <ng-content select="[status]"></ng-content>
</div>
